import React from 'react';
import './level1.css'
import Header from '../components/layout/header';
import pic11 from '../assets/pic11.png'
import pic48 from '../assets/pic48.png'
import Settings from '../components/common/settings';
import pic50 from '../assets/pic50.png'
import pic51 from '../assets/pic51.png'
import pic52 from '../assets/pic52.png'
import pic53 from '../assets/pic53.png'
import pic55 from '../assets/pic55.png'
import pic56 from '../assets/pic56.png'
import AudioContext from '../components/common/AudioContext';
import pic35 from '../assets/pic35.png'
import './howtoplayinstructions.css'
import Primaryctashort from '../components/common/primaryshortcta';
import Secondaryctashort from '../components/common/secondaryshort';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import '../pages/level1-start.css'
import pic115 from '../assets/pic115.png'
import './level2-start.css'
import pic124 from '../assets/pic124.png'
import pic125 from '../assets/pic125.png'
import { useEffect } from 'react';
import { useState } from 'react';
import pic89 from '../assets/pic89.png'
import './level3-start.css'
import pic157 from '../assets/pic157.png'
import pic158 from '../assets/pic158.png'
import pic159 from '../assets/pic159.png'
import pic155 from '../assets/pic155.png'
import pic182 from '../assets/pic182.png'
import pic183 from '../assets/pic183.png'
import pic184 from '../assets/pic184.png'
import pic185 from '../assets/pic185.png'
import pic186 from '../assets/pic186.png'
import pic187 from '../assets/pic187.png'
import pic188 from '../assets/pic188.png'
import pic189 from '../assets/pic189.png'
import pic190 from '../assets/pic190.png'
import './level4-start.css'
import inlevel4Ahmed from '../audio/Inlevel4-Ahmed.mp3';
import inlevel4Sara from '../audio/Inlevel4-sara.mp3';
import inlevel4Teyah from '../audio/Inlevel4-Teyah.mp3';
import Inlevel4mohammed from '../audio/Inlevel4mohammed.mp3'
import pic230 from '../assets/pic230.png'
import Inlevel4mariam from '../audio/Inlevel4-mariam.mp3'

const Level4start = () => {
    const [settingsOpen, setSettingsOpen] = useState(false);
    const [closing, setClosing] =useState(false);
    const { soundVolume } = React.useContext(AudioContext);
    const audioRef = React.useRef(null);
     const navigate = useNavigate();
           const selectedCharacter =
    localStorage.getItem('selectedCharacter') || 'Mohammed Tout';

    useEffect(() => {
        const audio = audioRef.current;
        if (!audio) return;
        audio.volume = soundVolume;
        audio.play().catch(() => {});

        return () => {
            audio.pause();
            audio.currentTime = 0;
        };
    }, []);

    useEffect(() => {
        if (audioRef.current) audioRef.current.volume = soundVolume;
    }, [soundVolume]);


const handleBack = () => {
  setClosing(true);
    setTimeout(() => navigate(-1), 400);
};

const handleStart = () => {
  setClosing(true);
  setTimeout(() => navigate('/level4'), 400);
};



const getLevel4Audio = () => {
    if (selectedCharacter === 'Ahmad Amon') return inlevel4Ahmed;
    if (selectedCharacter === 'Sarah Idress') return inlevel4Sara;
    if (selectedCharacter === 'Teyah Ramses') return inlevel4Teyah;
    if (selectedCharacter === 'Mariam Lotus') return Inlevel4mariam;
    return Inlevel4mohammed; 
};

const level4Audio = getLevel4Audio();






    return ( 
        <>
<main className='level1--page'>
            <section className='levelbackground--page'>
                 {settingsOpen && <Settings onClose={() => setSettingsOpen(false)} />}
 <>
            <audio ref={audioRef}
                src={level4Audio}
                preload="auto" />

               <section className='settings-background'>
            <section className={`level2start-overlay ${closing ? 'slide-down' : 'slide-up'}`}>

                <section className='header-overlay'>
                    <div className='header-title-cont-settings'>
                        <h2 className='title-containerr-settings'>Level 4</h2>
                        <h2 className='title2-container-settings'>Level 4</h2>
                    </div>
                    
                        <button className='circlecta-cont' >
                        <div onClick={handleStart}>
                            <div className='circle-red'>
                                <img className='close-img' src={pic35} alt='close'></img>
                            </div>
                        </div>
                    </button>
                </section>

                


                <section className='container-level4start'>

                    <figure className='container-imgs-leve4-start'>
                        <div className="row">
                        <img className='pic1-leve2-start' src={pic183} alt='artifice 1'></img>
                        <img className='pic1-leve2-start' src={pic184} alt='artifice 2'></img>
                        <img className='pic1-leve2-start' src={pic185} alt='artifice 3'></img>
                        <img className='pic1-leve2-start' src={pic186} alt='artifice 4'></img>
                        </div>
                        <div className="row">
                        <img className='pic1-leve2-start' src={pic187} alt='artifice 5'></img>
                        <img className='pic1-leve2-start' src={pic188} alt='artifice 6'></img>  
                        <img className='pic1-leve2-start' src={pic189} alt='artifice 6'></img>    
                        </div>                                           
                    </figure>
                    <section className='container-audio'>

                        <p className='para-mission'>Collect these seven 
                            artifices and avoid touching obstacles</p>

                    </section>
                </section>



                <div className='container-continue-how-to-play' >
                    <div onClick={handleBack}>
                        <Secondaryctashort  title='Back'/>
                    </div>
                    <div onClick={handleStart}>
                    <Primaryctashort title='start' />
                    </div>
                 
                </div>



                </section>
            </section>
        </>
                         <div className='HUD-container-level-start'>


                        <div   className={`frame-Hud-level-start ${closing ? 'slide-down' : 'slide-up'}`}>
                            <div className='HUD-1-container-level-start'>

                                <img className='decoration-HUD' src={pic55} alt='decoration-HUD'></img>
                                <div className='quote-container'>
                                    <h2 className='lets-start-text'>Lets Start Now</h2>
                                </div>

                                <img className='charcter-level-start' 
                                src={
                                     selectedCharacter === 'Ahmad Amon'
                                    ? pic182                                   
                                    :selectedCharacter === 'Sarah Idress'
                                    ? pic115
                                     : selectedCharacter === 'Mariam Lotus'
                                    ?pic230   
                                    : selectedCharacter === 'Teyah Ramses'
                                        ? pic155
                                        : pic89
                                    }
                                // src={pic115} 
                                // src={pic89} 
                                alt='character'></img>




                            </div>


                        </div>
                    </div>
                <div className='background-and-obstacles-layer2-level4 '>
                    <div className='container-obtsacles-and-collections'>
                        <img className='obstacle1-level3' src={pic157} alt='obstacle-1'/>
                        {/* <img className='obstacle2' src={pic58} alt='obstacle-2'/> */}
                        <img className='obstacle2-level3'  src={pic158} 
                        // src={pic59} 
                        alt='obstacle-3'/>

                        <img className='obstacle3-level2'  src={pic125} 
                        // src={pic59} 
                        alt='obstacle-3'/>

                        <img className='obstacle4-level2 '  src={pic125} 
                        // src={pic59} 
                        alt='obstacle-3'/>          

                         <img className='obstacle4-level3 '  src={pic124} 
                        // src={pic59} 
                        alt='obstacle-4'/>    


                         <img className='obstacle5-level3 '  src={pic159} 
                        // src={pic59} 
                        alt='obstacle-4'/>                                                                          

                    </div>
                </div>


             {/* <section className='container-items-home-page'>
               <section className='container-charcater-page'>
                    </section>
              </section> */}
   
                <section className='container-hedaer-and-character-levels-page'>
                    <Header 
                    title='Level 4' title2='Level 4 '
                    link='/home'  onClick={() => setSettingsOpen(true)}
                    img={pic48} icontext='pause icon'
                    img2={pic11} icontext2='settings icon'/>
                 <img className='character-movement'
                 src={pic190}
                //   src={pic54} 
                  alt='character'></img>




                    <div className='HUD-container'>

                            <div className='lives-frame-Hud'>
                                <div className='lives-container-HUD'>
                                    <img className='decoration2-HUD' src={pic56} alt='decoration-HUD'></img>
                                    <div className='hearts-container'>
                                        <img src={pic53} alt='heart'></img>
                                        <img src={pic53} alt='heart'></img>
                                        <img src={pic53} alt='heart'></img>
                                    </div>
                                </div>
                            </div>

                        <div className='frame-Hud'>
                            <div className='HUD-1-container'>

                                <img className='decoration-HUD' src={pic55} alt='decoration-HUD'></img>

                                <h2 className='collect-text'>Collect:</h2>
                                <div className='row-pic-HUD'>
                                    <div className='img-container-HUD'> 
                                        <img src={pic50} alt='collect-item-1'></img>
                                    </div>

                                    <div className='img-container-HUD'> 
                                        <img src={pic51} alt='collect-item-1'></img>
                                    </div>


                                    <div className='img-container-HUD'> 
                                        <img src={pic52} alt='collect-item-1'></img>
                                    </div>

                                </div>
                            </div>


                        </div>
                    </div>



                </section>
            </section>
          </main>

         </>
     );
}
 

 
export default Level4start;